export default function ArrowRightSearch({ className }) {
    return (
        <svg  className={className}  width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4768 6.16667L6.00683 1.69667L7.18516 0.518341L13.6668 7.00001L7.18516 13.4817L6.00683 12.3033L10.4768 7.83334H0.333496V6.16667H10.4768Z" fill="currentColor"/>
        </svg>
    );
}

